import React from "react";
import { BiMinus, BiPlus } from "react-icons/bi";

export const Counter = ({
  value,
  onChange,
  min = 0,
  max = 99,
  dataCy,
}: {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  dataCy?: string;
}) => (
  <div className="inline-flex items-center gap-2">
    <button
      type="button"
      data-cy={dataCy ? `${dataCy}-decrease` : undefined}
      aria-label="Verringern"
      disabled={value <= min}
      onClick={() => onChange(Math.max(min, value - 1))}
      className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-line bg-surface-card text-ink-muted hover:bg-surface disabled:opacity-40"
    >
      <BiMinus className="h-4 w-4" />
    </button>
    <span className="min-w-[2ch] text-center font-bold text-ink">{value}</span>
    <button
      type="button"
      data-cy={dataCy ? `${dataCy}-increase` : undefined}
      aria-label="Erhöhen"
      disabled={value >= max}
      onClick={() => onChange(Math.min(max, value + 1))}
      className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gold bg-gold/10 text-gold hover:bg-gold/20 disabled:opacity-40"
    >
      <BiPlus className="h-4 w-4" />
    </button>
  </div>
);
